import React from 'react';
import { FileText } from 'lucide-react';
import Header from '@/components/layout/Header';
import FooterNew from '@/components/layout/FooterNew';

const MentionsPage = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      
      <main className="flex-1">
        <section className="bg-gradient-to-br from-red-50 to-cyan-50 py-12">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center">
              <FileText className="w-12 h-12 text-red-600 mx-auto mb-4" />
              <h1 className="text-4xl font-bold gradient-text mb-4">
                Mentions légales
              </h1>
              <p className="text-gray-600">Informations légales sur Coli Noki</p>
            </div>
          </div>
        </section>

        <section className="py-12">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto prose prose-lg">
              <h2>1. Éditeur du site</h2>
              <p>
                <strong>Nom de la société :</strong> Coli Noki SARL<br />
                <strong>Forme juridique :</strong> Société à Responsabilité Limitée<br />
                <strong>Capital social :</strong> [À compléter] FCFA<br />
                <strong>Siège social :</strong> Brazzaville, République du Congo<br />
                <strong>Numéro d'immatriculation :</strong> [À compléter]<br />
                <strong>Téléphone :</strong> +242 05 087 12 50<br />
                <strong>Email :</strong> contact@colinoki.com
              </p>

              <h2>2. Directeur de la publication</h2>
              <p>
                <strong>Nom :</strong> [À compléter]<br />
                <strong>Qualité :</strong> Gérant<br />
                <strong>Email :</strong> direction@colinoki.com
              </p>

              <h2>3. Hébergement</h2>
              <p>
                <strong>Hébergeur :</strong> [Nom de l'hébergeur]<br />
                <strong>Adresse :</strong> [Adresse de l'hébergeur]<br />
                <strong>Téléphone :</strong> [Téléphone de l'hébergeur]
              </p>

              <h2>4. Propriété intellectuelle</h2>
              <p>
                L'ensemble du contenu de ce site (textes, images, logos, vidéos, etc.) est la propriété 
                exclusive de Coli Noki ou de ses partenaires. Toute reproduction, même partielle, est 
                strictement interdite sans autorisation préalable écrite.
              </p>

              <h3>4.1 Marques</h3>
              <p>
                "Coli Noki" et le logo associé sont des marques déposées. Leur utilisation sans 
                autorisation est passible de poursuites.
              </p>

              <h3>4.2 Contenus utilisateurs</h3>
              <p>
                En publiant du contenu sur la plateforme (photos, commentaires), vous accordez à 
                Coli Noki une licence d'utilisation non exclusive dans le cadre de la fourniture de nos services.
              </p>

              <h2>5. Protection des données personnelles</h2>
              <p>
                Conformément au RGPD et aux lois locales sur la protection des données, vous disposez d'un 
                droit d'accès, de rectification et de suppression de vos données personnelles. 
                Consultez notre <a href="/privacy" className="text-red-600 hover:underline">Politique de confidentialité</a> 
                pour plus d'informations.
              </p>

              <h2>6. Responsabilité</h2>
              <h3>6.1 Contenu du site</h3>
              <p>
                Coli Noki s'efforce de fournir des informations exactes et à jour. Toutefois, nous ne 
                pouvons garantir l'exactitude, la complétude ou l'actualité des informations diffusées.
              </p>

              <h3>6.2 Disponibilité du service</h3>
              <p>
                Coli Noki ne peut être tenu responsable des interruptions de service dues à :
              </p>
              <ul>
                <li>Des opérations de maintenance</li>
                <li>Des pannes techniques</li>
                <li>Des cas de force majeure</li>
                <li>Des actes de tiers (piratage, virus, etc.)</li>
              </ul>

              <h3>6.3 Liens externes</h3>
              <p>
                Notre site peut contenir des liens vers des sites tiers. Coli Noki n'est pas responsable 
                du contenu de ces sites externes ni des dommages pouvant résulter de leur utilisation.
              </p>

              <h2>7. Cookies</h2>
              <p>
                Ce site utilise des cookies pour améliorer votre expérience. Consultez notre 
                <a href="/legal/cookies" className="text-red-600 hover:underline"> Politique des cookies</a> 
                pour plus d'informations sur leur utilisation et leur gestion.
              </p>

              <h2>8. Droit applicable et juridiction</h2>
              <p>
                Les présentes mentions légales sont régies par le droit congolais. En cas de litige, 
                et à défaut de résolution amiable, les tribunaux de Brazzaville seront seuls compétents.
              </p>

              <h2>9. Contact</h2>
              <p>
                Pour toute question concernant ces mentions légales :
              </p>
              <ul>
                <li><strong>Adresse postale :</strong> Coli Noki, [Adresse complète], Brazzaville, Congo</li>
                <li><strong>Téléphone :</strong> +242 05 087 12 50</li>
                <li><strong>Email :</strong> legal@colinoki.com</li>
              </ul>

              <h2>10. Mise à jour</h2>
              <p>
                Coli Noki se réserve le droit de modifier les présentes mentions légales à tout moment. 
                Les modifications prennent effet dès leur publication sur le site.
              </p>

              <p className="text-sm text-gray-600 italic mt-8">
                Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
              </p>
            </div>
          </div>
        </section>
      </main>

      <FooterNew />
    </div>
  );
};

export default MentionsPage;
